import React from "react";

const items = [
  "London · W1D",
  "Mayfair",
  "Knightsbridge",
  "Belgravia",
  "Manhattan",
  "Tribeca",
  "Singapore",
  "Monaco",
  "Hong Kong",
  "Lisbon",
];

export default function Marquee() {
  return (
    <section data-testid="marquee-section" className="border-y border-[#D6CDBB] bg-[#EFEBE4]/60 py-6 overflow-hidden">
      <div className="relative">
        <div className="flex marquee-track gap-14 whitespace-nowrap">
          {[...items, ...items].map((item, i) => (
            <span
              key={i}
              className="font-serif-display italic text-xl md:text-2xl text-[#6E5A4E]"
            >
              {item}
              <span className="mx-7 text-[#B89A7E]">◦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
